import React, { useEffect, useState } from 'react';
import instance from 'api/instance';
import { getWeatherDescription } from '@utils/weatherCondition';
import { Box, Typography } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import WavesIcon from '@mui/icons-material/Waves';
import useToggle from '@utils/useToggle';
export default function Temperatura() {
    const [temperatura, setTemperatura] = useState('');
    const [estadoSol, setEstadoSol] = useState('');
    const [estadoSolImage, setEstadoSolImage] = useState('');
    const rootStyles = getComputedStyle(document.documentElement);
    const principalColor = rootStyles.getPropertyValue('--primary-color');
    const [lng, setLng] = useState<number | null>(null);
    const [lat, setLat] = useState<number | null>(null);
    const [aemetUrl, setAemetUrl] = useState('null');
    const [configLoaded, setConfigLoaded] = useToggle(false);

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                const { MAP_CENTER } = config;
                setLng(MAP_CENTER.lng);
                setLat(MAP_CENTER.lat);
                setAemetUrl(config.AEMET_URL)
                setConfigLoaded(true)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (configLoaded) {

            const fetchData = async () => {
                // URL de la API de Open-Meteo para obtener el tiempo actual
                const apiUrl = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current_weather=true`;
                instance
                    .get(apiUrl)
                    .then((response) => {
                        const weatherData = response.data.current_weather;
                        setTemperatura(`${weatherData.temperature}`);
                        setEstadoSol(getWeatherDescription(weatherData.weathercode)[0]);
                        setEstadoSolImage(getWeatherDescription(weatherData.weathercode)[1]);
                    })
                    .catch((error) => {
                        console.error('Error al hacer la solicitud:', error);
                    });
            };


            fetchData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configLoaded]);

    return (
        <a href={aemetUrl} style={{ textDecoration: 'none' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: principalColor,
                    color: '#ffffff',
                    borderRadius: 2,
                    boxShadow: 1,
                    height: '60px',
                    textAlign: 'center',
                }}
            >
                <Box sx={{ mr: 2, ml: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '40%' }}>
                    {estadoSolImage === 'sunny' && <LightModeIcon sx={{ width: '40px', height: '40px' }} />}
                    {estadoSolImage === 'cloud' && <CloudQueueIcon sx={{ width: '40px', height: '40px' }} />}
                    {estadoSolImage === 'snow' && <AcUnitIcon sx={{ width: '40px', height: '40px' }} />}
                    {estadoSolImage === 'rain' && <InvertColorsIcon sx={{ width: '40px', height: '40px' }} />}
                    {estadoSolImage === 'wave' && <WavesIcon sx={{ width: '40px', height: '40px' }} />}
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', mb: 0 }}>
                            {temperatura}
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 0, marginLeft: '4px' }}>
                            °C
                        </Typography>
                    </Box>
                </Box>

                <Typography variant="h6" style={{ width: '60%' }} component="div">
                    {estadoSol}
                </Typography>
            </Box>
        </a>
    );
}
